import { axiosPost } from "../../react_axios/Axios";
import {
  authUrl,
  platform,
  LOGIN_ACTION_TYPE,
  headers,
  changePasswordUrl,
  CHANGE_PASSWORD_ACTION_TYPE,
  FORGET_PASSWORD_ACTION_TYPE,
  forgetPasswordUrl,
  loginUrl,
  getOtpUrl,
  GET_OTP_ACTION_TYPE,
  updatePasswordUrl,
  UPDATE_PASSWORD_ACTION_TYPE,
  SIGNUP_ACTION_TYPE,
  signUpUrl,
} from "../../utils/constants";

export const login_action = (Email, password) => async (dispatch) => {
  try {
    const mapdata = {
      Email: Email,
      Password: password,
    };

    const res = await axiosPost(loginUrl, mapdata);
    console.log("**********", res);
    if (res["error"] != 1) {
      sessionStorage.setItem("UserLoginData", JSON.stringify(res["data"]));

      sessionStorage.setItem(
        "loginAccesslist",
        JSON.stringify(res["data"]["loginAccesslist"])
      );
      sessionStorage.setItem(
        "reportAccesslist",
        res["data"]["reportAccesslist"]
      );
      sessionStorage.setItem("userId", res["data"]["UserID"]);
      sessionStorage.setItem("roleId", res["data"]["RoleID"]);
      sessionStorage.setItem("ClientID", res["data"]["ClientID"]);
      sessionStorage.setItem("VendorID", res["data"]["VendorID"]);
      sessionStorage.setItem("accessToken", res["data"]["accessToken"]);
      sessionStorage.setItem("refreshToken", res["data"]["refreshToken"]);
      // console.log(" res['data']", res['data']['RoleID'])
      // console.log('*** login information **')
      // console.log('UserLoginData', res['data'])
      // console.log('userId***', res)
      // console.log('loginAccesslist', res['data']['loginAccesslist'])
      // console.log('reportAccesslist', res['data']['reportAccesslist'])
      // console.log('ClientID', res['data']['ClientID'])
    }

    dispatch({
      type: LOGIN_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const changePassword_action =
  (oldPassword, newPassword) => async (dispatch) => {
    try {
      const mapdata = {
        loginUserID: parseInt(sessionStorage.getItem("userId")),
        // platform: platform,
        oldPassword: oldPassword.toString().trim(),
        newPassword: newPassword.toString().trim(),
      };
      // console.log("mapdata", mapdata)
      const res = await axiosPost(changePasswordUrl, mapdata, headers);
      dispatch({
        type: CHANGE_PASSWORD_ACTION_TYPE,
        payload: res,
      });

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const forgetPassword_action = (email) => async (dispatch) => {
  try {
    const mapdata = {
      UserID: null,
      EmailID: email,
    };
    // departmentId != '' ? departmentId : null

    const res = await axiosPost(forgetPasswordUrl, mapdata, headers);
    // console.log("forgetPassword_action", forgetPasswordUrl, mapdata)
    dispatch({
      type: FORGET_PASSWORD_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getOtp_action = (email) => async (dispatch) => {
  try {
    const mapdata = {
      UserID: parseInt(sessionStorage.getItem("userId")),
      Email: email,
    };

    // console.log("getOtpUrl action", getOtpUrl, mapdata)
    const res = await axiosPost(getOtpUrl, mapdata, headers);
    dispatch({
      type: GET_OTP_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const update_action = (password) => async (dispatch) => {
  try {
    const mapdata = {
      UserID: sessionStorage.getItem("userIdForget"),
      Password: password,
    };
    // console.log("update Password", mapdata)
    const res = await axiosPost(updatePasswordUrl, mapdata);
    // console.log("update_action action", updatePasswordUrl, mapdata)

    dispatch({
      type: UPDATE_PASSWORD_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const signUp_action = (name, phone, email, password) => async (dispatch) => {
  try {
    const mapdata = {
      UserID: null,
      Name: name,
      Phone: phone,
      Email: email,
      Password: password,
    };

    const res = await axiosPost(signUpUrl, mapdata, headers);
    console.log(res, 'response signup');

    if (res && res.error !== 1) {
      // success case: error !== 1
      var userData = res.data.recordsets[0][0];
      var loginAccesslist = res.data.recordsets[2];
      var reportAccesslist = res.data.recordsets[1];
      userData = {
        ...userData,
        loginAccesslist: loginAccesslist,
        reportAccesslist: reportAccesslist,
      };
      sessionStorage.setItem("UserLoginData", JSON.stringify(userData));
      sessionStorage.setItem("loginAccesslist", JSON.stringify(loginAccesslist));
      sessionStorage.setItem("userId", res.data.recordsets[0][0]["UserID"]);
      sessionStorage.setItem("roleId", res.data.recordsets[0][0]["RoleID"]);
    } else if (res && res.error === 1) {
      console.warn('Email already exists:', res.msg);
    } else {
      console.warn('No response or invalid response from server.');
    }

    dispatch({
      type: SIGNUP_ACTION_TYPE,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
